import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BookingFormDateChangePageRoutingModule } from './booking-form-date-change-routing.module';

import { BookingFormDateChangePage } from './booking-form-date-change.page';

import { CalendarComponentModule } from '../../calendar/calendar.module';
import { NavController, NavParams } from '@ionic/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BookingFormDateChangePageRoutingModule,
    CalendarComponentModule
  ],
  providers:[NavParams],
  declarations: [BookingFormDateChangePage]
})
export class BookingFormDateChangePageModule {}
